import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { VariablesGlobalesService } from '../variables-globales.service';
import { AMRespuestaGET } from '../../Models/RespuestaGET/AMRespuestaGET';
import { globalConf } from 'src/GlobalConf';
import { AMRespuestaPOSTPUT } from '../../Models/RespuestaPOSTPUT/AMRespuestaPOSTPUT';

export interface DTO_AuditoriaAplicacion {
  id?:number;
  guidRegistro?:string;
  fichero?:string;
  fechaOperacion?:string;
  operacion:string;
  texto?:string;
  fecha?:string;
  ipUsuario?:string;
  idRegistroFichero?:number;
  guidEmpresa?:string;
  idEmpresa?:string;
  idEmpresaRemota?:string;
  baseDeDatos?:string;
  usuario:string;
  idUsuario?:number;
  perfil?:string;
  dispositivo?:string;
  scope?:string;
  frecaCreacion?:string;
  fechaModificacion?:string;
  fechaBorradoLogico?:string;
  borradoLogico?:boolean;
  idCreador?:number;
  idEditor?:number;
  idBorrador?:number;
}

@Injectable({
  providedIn: 'root'
})

export class AuditoriaAplicacionesService {
  private http = inject(HttpClient);
  private variablesGlobales = inject(VariablesGlobalesService);

  path_Auditoria_Aplicaciones: string = "api/v2/auditoriaaplicaciones/alosuiteapp/"

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() { }

  // AuditoriaAplicacionesGET
  /**
   * GET /api/v2/auditoriaAplicaciones/{aplicacion}/{guidEmpresa}/{id}
   * Método para realizar la petición a ALO solicitanto los logs de una aplicación
   * @param listaParametros filtros para aplicar en la petición para la obtención de logs
   * @returns any
   */
  getLogsAuditoriaAplicaciones(listaParametros):Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + this.path_Auditoria_Aplicaciones + this.variablesGlobales.empresaActual.GUID_Registro, { params: listaParametros });
  }

    // AuditoriaAplicacionesPOST
  /**
   * POST /api/v2/auditoriaAplicaciones/{aplicacion}/{guidEmpresa}
   * Método para realizar la petición a ALO para grabar los logs de una aplicación
   * @param logAplicacion log que queremos almacenar
   * @returns any
   */
  postLogsAuditoriaAplicaciones(logAplicacion: DTO_AuditoriaAplicacion):Observable<AMRespuestaPOSTPUT> {
    var logAplicacionJson = []
    logAplicacionJson.push(logAplicacion)
    console.log('Log a guardar: ',logAplicacionJson);
    return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + this.path_Auditoria_Aplicaciones + this.variablesGlobales.empresaActual.GUID_Registro, logAplicacionJson);
  }
}
